<template>
  <div class="search-result">
    <div class="search-result-header">
      <h4 class="search-result-title">
        <a class="" :href="`${prog.url}?international=true`">{{ prog.name }}</a>
      </h4>
      <h5 class="search-result-subtitle">{{ prog.code }}</h5>
    </div>
    <div class="search-result-body">
      <p class="">{{ prog.description }}</p>
    </div>

    <div class="search-result-footer">
      <!-- <div
        v-if="prog.intDistance"
        class=""
        style="
          flex: 1 1 100%;
          margin: 1rem 1rem 0;
          border-left: 5px solid #831212;
          padding: 0.5rem;
          background-color: #fff;
          border-radius: 2px;
        "
      >
        <p>
          This programme can be started online if you are outside New Zealand.
        </p>
      </div> -->

      <div class="search-result-footer-item" v-if="prog.duration">
        <h5 class="meta-label">
          <i aria-hidden="true" class="icon-clock"></i>
          <span class="meta-labelText">Duration</span>
        </h5>
        <p class="">{{ prog.duration }}</p>
      </div>

      <div class="search-result-footer-item" v-if="prog.points">
        <h5 class="meta-label">
          <i aria-hidden="true" class="icon-graduation-cap"> </i>
          <span class="meta-labelText">Points</span>
        </h5>
        <p class="">{{ prog.points }}</p>
      </div>

      <div class="search-result-footer-item">
        <h5>
          <i class="icon-calendar"></i>
          <span class="meta-labelText">Next start date</span>
        </h5>
        <p class="">{{ startDate }}</p>
      </div>

      <div class="search-result-footer-item">
        <h5 class="meta-label">
          <i aria-hidden="true" class="icon-money"></i>
          <span class="meta-labelText">Estimated fees</span>
        </h5>
        <p
          class=""
          v-if="prog.internationalFeeTotal && prog.internationalFeeTotal != 0"
        >
          {{ prog.internationalFeeTotal | currency("NZ$", 0) }}
          {{ prog.internationalFeeTerm }}
        </p>
        <p class="" v-else>To be advised</p>
      </div>

      <!-- <div class="search-result-footer-item">
               <h5 class="meta-label"><i aria-hidden="true" class="icon-money"></i> <span class="meta-labelText">Estimated fees</span></h5>
              <p class="" v-if="prog.feeTuition">

                  {{prog.feeTuition | currency('$', 0) }}  {{prog.feePeriod}} 

              </p>
              <p class="" v-else>
                Not currently available
              </p>
        </div> -->

      <!-- <div class="search-result-footer-item">
          <h5><i class="icon-calendar"></i>Year</h5>
          <p class="">2020</p>
        </div> -->
    </div>
  </div>
</template>

<script>
import Vue2Filters from "vue2-filters";
import moment from "moment";

export default {
  name: "ugprogramme",
  props: ["prog"],
  computed: {
    startDate() {
      if (this.prog.keyDateSet) {
        let dates = this.prog.keyDateSet.filter( dates => dates.international == true)
        .map((dateSet) => {
          console.log('international: ', dateSet.international);
          return dateSet.startDate;
        });

        //removes null objects
        let startDates = dates
          .filter(Boolean)
          .map((d) => {
            return moment(d.date).format("YYYYMMDD");
          })
          .sort((a, b) => a - b);

        //get next date
        const today = moment().format("YYYYMMDD");
        const nextDate = startDates.find((d) => d > today);

        if (nextDate > today) {
          return moment(nextDate).format("DD MMM YYYY");
        } else {
          return "To be advised";
        }
      } else {
        return "To be advised";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.c-stack-body {
  .meta--labelled {
    margin-bottom: 0;
  }
}
</style>